import controller from './fizy-logo.controller';
import './fizy-logo.less';

export default {
  bindings: {
    href: '<?'
  },
  controller,
  template: require('./fizy-logo.html')
};



// WEBPACK FOOTER //
// src/app/components/fizy-logo/fizy-logo.component.ts